/**
 * Type de styles possibles pour les boutons radios
 */
enum ERadioType {
    "RECTANGLE" = "radio-button",
    "CIRCLE" = "radio-button-with-circle",
    "SIMPLE" = "radio-simple"
}

export default ERadioType;